export const links = {
  youtube: 'https://www.youtube.com/channel/UCJUnwi6VGTBLlO-ZNKmOecg',
  facebook: 'https://www.facebook.com/planoangelusrs',
  linkedin: 'https://www.linkedin.com/company/grupo-angelus',
  instagram: 'https://www.instagram.com/planoangelusrs',
  assistancesManual: 'www.angelus.com.br/manual',
};

export const footerLinks = [
  {
    label: 'NOSSAS UNIDADES',
    href: 'https://www.angelus.com.br/unidades',
  },
  {
    label: 'CONTATO',
    href: 'https://www.angelus.com.br/contato',
  },
  {
    label: 'POLÍTICA DE PRIVACIDADE',
    href: 'https://www.angelus.com.br/politicas',
  },
];

export const email = null;

export const company =
  'Prever Angelus Assistência Funeral Familiar Ltda CNPJ: 09.088.053/0001-80';

export const tenant = 'angelus_rs';

export const state = 'Rio Grande do Sul';

export const slug = 'rs';

export const product = 'Prever Angelus Rio Grande do Sul';

export const brand = 'Prever Angelus';

export const plansLabel = 'Planos';

export const description =
  'Plano Prever Angelus é referência em assistência familiar no Sul do Brasil. ';

export const coverage =
  'Assistência funeral com cobertura nacional nos planos Neo, Bem Estar, Bem Seguro e Multiassistência';
